module.exports = __webpack_public_path__ + "static/media/paola.dc57fdce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/paola.jpg
// module id = 1216
// module chunks = 0